import { RAIL_STATE_IDS, VIDEO_LAYOUT_IDS } from './layoutIds'

const EMPTY_IDS = Object.freeze([])

/**
 * @typedef {object} VideoLayoutModel
 * @property {string} layoutId
 * @property {string | null} railStateId
 * @property {string | null} primaryParticipantId
 * @property {string[]} secondaryParticipantIds
 * @property {string[]} gridParticipantIds
 * @property {string[]} railParticipantIds
 * @property {string | null} selfPreviewParticipantId
 * @property {string | null} screenShareParticipantId
 * @property {string[]} hiddenParticipantIds
 * @property {string[]} availableRailStateIds
 * @property {string} controlsOverlayMode
 * @property {boolean} hasRail
 * @property {boolean} useFullVideoRegion
 * @property {boolean} screenShareHeroMode
 */

export function createEmptyVideoLayoutModel({
  layoutId = VIDEO_LAYOUT_IDS.stageOverlay,
  railStateId = RAIL_STATE_IDS.stacked,
  controlsOverlayMode = 'overlay',
  useFullVideoRegion = true,
  screenShareHeroMode = false,
} = {}) {
  return {
    layoutId,
    railStateId,
    primaryParticipantId: null,
    secondaryParticipantIds: EMPTY_IDS,
    gridParticipantIds: EMPTY_IDS,
    railParticipantIds: EMPTY_IDS,
    selfPreviewParticipantId: null,
    screenShareParticipantId: null,
    hiddenParticipantIds: EMPTY_IDS,
    availableRailStateIds: EMPTY_IDS,
    controlsOverlayMode,
    hasRail: false,
    useFullVideoRegion,
    screenShareHeroMode,
  }
}
